"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Faq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const faqs = [{
    question: "Where is your clinic located in Limassol?",
    answer: "Our Limassol clinic is conveniently situated in the heart of the city near the Marina. We offer dedicated parking for our patients and are easily accessible via public transport, ensuring a stress-free arrival for your appointment."
  }, {
    question: "Do you offer consultations in English and Greek?",
    answer: "Yes, all our medical specialists are fully bilingual in English and Greek. We pride ourselves on serving Limassol's diverse international community with clear, professional communication regarding all health concerns."
  }, {
    question: "How can I book an appointment at the Limassol branch?",
    answer: "You can book directly through our online portal, call our Limassol office during business hours, or visit us in person. We offer flexible scheduling, including early morning and late evening slots to accommodate your lifestyle."
  }, {
    question: "What specialized treatments are available in Limassol?",
    answer: "Our Limassol facility provides a full range of services including specialized physiotherapy, advanced diagnostic imaging, and personalized wellness programs designed to address the specific health needs of our local patients."
  }, {
    question: "Is there a waiting list for new patients?",
    answer: "We strive to see new patients within 48 hours of their initial inquiry. Emergency cases or acute pain management requests are prioritized, often allowing for same-day consultations with our available specialists."
  }];
  return <section data-section-id="33064" id="limassol-specific-faq" className="bg-background py-24 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div ref={ref} className={cn("max-w-[800px] mx-auto transition-all duration-700 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <div className="text-center mb-12">
            <h2 className="text-5xl font-bold tracking-tight text-foreground mb-4 font-serif">
              Limassol Clinic FAQ
            </h2>
            <p className="text-muted-foreground text-lg font-sans">
              Find answers to common questions about our services and facilities in Limassol.
            </p>
          </div>

          <div className="bg-card rounded-xl shadow-sm overflow-hidden border border-border">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-border last:border-0 px-8" data-index={i}>
                  <AccordionTrigger className={cn("text-foreground font-bold font-serif text-xl py-7 hover:no-underline transition-all duration-200 hover:text-accent", "data-[state=open]:text-accent", "[&_svg]:!text-muted-foreground [&_svg]:size-5")}>
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-secondary-foreground font-sans text-base leading-relaxed pb-7 [animation-duration:200ms]">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>

          <div className="mt-10 text-center">
            <p className="text-muted-foreground font-sans">
              Still have specific health questions?{" "}
              <Link to="/ContactPage" className="text-accent font-semibold hover:underline underline-offset-4">
                Speak with a Specialist
              </Link>
            </p>
          </div>
        </div>
      </div>
    </section>;
}